import PropTypes from "prop-types";

export const templatePropTypes = {
    onBlockMount: PropTypes.func.isRequired,
    onNewsClick: PropTypes.func.isRequired,
    onTeaserClick: PropTypes.func.isRequired,
    onInternalClick: PropTypes.func.isRequired,
    onCategoryClick: PropTypes.func.isRequired,
    onRecommendationClick: PropTypes.func.isRequired,

    loading: PropTypes.bool.isRequired,

    data: PropTypes.object.isRequired,
    scrollData: PropTypes.array.isRequired,
    lastLoadTeasers: PropTypes.array,

    news: PropTypes.object.isRequired,
    nextNews: PropTypes.object,
    categories: PropTypes.array.isRequired,

    currency: PropTypes.object,

    geoCity: PropTypes.string
};

export const DEVICE = {
    mobile: "mobile",
    desktop: "desktop",
    tablet: "tablet"
};

export const fetchJsonAdsCount = 49;

export const TERMS_OF_USE_URL = 'https://docs.glavnoe.life/informatsiya_o_portale_glavnoe_live.pdf'
export const PRIVACY_POLICY_URL = 'https://docs.glavnoe.life/pravila_zashchity_informatsii_glavnoe_live.pdf'
export const COOKIES_POLICY_URL = 'https://docs.glavnoe.life/politika_obrabotki_faylov_cookie_glavnoe_live.pdf'

export const VIEW_DURATION = 31000;
export const MIN_VIEW_DURATION = 2000;
export const THRESHOLD = 0.5;
